// Constants.js

const prod = {
  urls: {
    ACCOUNT_URL: 'https://account-be.intego.com',
  },
}

const dev = {
  urls: {
    ACCOUNT_URL: 'https://account-be-staging.intego.com',
  },
}

// export const config = prod
export const config = process.env.NODE_ENV === 'production' ? prod : dev

export const LINKS = {
  newAccountUrl : {
    stage: "https://account-staging-v2.intego.com",
    prod: "https://account-v2.intego.com"
  }
}

export const MIXPANEL_TOKEN = 'f703d0c95e8a775d931da831be4e7a98'